export default "__VITE_ASSET__CwM$OgqW__"